import * as React from "react";
const SvgLensFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M20 11a9 9 0 1 0-9 9 8.96 8.96 0 0 0 5.618-1.968l3.675 3.675a1 1 0 0 0 1.414-1.414l-3.675-3.675A8.96 8.96 0 0 0 20 11" }));
export default SvgLensFill;
